var _desc, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, "Documents") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "d"
  }, "Pile de feuilles isometriques, une piece relevee.")), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n  :root{\n    --line:#025D7D;\n    --accent:#30C5E5;\n  }\n  @media (prefers-color-scheme: dark){\n    :root{ --line:#7FD8EE; --accent:#30C5E5; }\n  }\n  .e   {fill:none;stroke:var(--line);stroke-width:2.6;stroke-linecap:round;stroke-linejoin:round}\n  .e2  {fill:none;stroke:var(--line);stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round;opacity:.7}\n  .e3  {fill:none;stroke:var(--line);stroke-width:1.2;stroke-linecap:round;opacity:.34}\n  .h   {fill:none;stroke:var(--line);stroke-width:1.2;stroke-linecap:round;opacity:.22;stroke-dasharray:4 6}\n  .a   {fill:none;stroke:var(--accent);stroke-width:2.8;stroke-linecap:round;stroke-linejoin:round}\n  .a2  {fill:none;stroke:var(--accent);stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round;opacity:.75}\n  .face {fill:var(--accent);opacity:.07;stroke:none}\n  .face2{fill:var(--accent);opacity:.16;stroke:none}\n  .faceL{fill:var(--line);opacity:.07;stroke:none}\n  .dot  {fill:var(--accent)}\n  .dotl {fill:var(--line);opacity:.45}\n  .txt  {fill:var(--line);font-family:Montserrat,'Helvetica Neue',Arial,sans-serif;font-weight:700}\n  .txta {fill:var(--accent);font-family:Montserrat,'Helvetica Neue',Arial,sans-serif;font-weight:700}\n  .halo {fill:var(--accent);opacity:.16;transform-box:fill-box;transform-origin:center;\n         animation:pulse 3.4s ease-in-out infinite}\n  .flow {stroke-dasharray:6 10;animation:flow 2.6s linear infinite}\n  .flow2{stroke-dasharray:4 8;animation:flow 3.4s linear infinite reverse}\n  .drift{transform-box:fill-box;transform-origin:center;\n         animation:drift 6s ease-in-out infinite}\n  #scene{animation:float 8s ease-in-out infinite}\n  @keyframes pulse{0%,100%{transform:scale(.62);opacity:.09}50%{transform:scale(1.32);opacity:.34}}\n  @keyframes flow {to{stroke-dashoffset:-32}}\n  @keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-7px)}}\n  @keyframes drift{0%,100%{transform:translate(0,0)}50%{transform:translate(0,-9px)}}\n  @media (prefers-reduced-motion: reduce){*{animation:none !important}}\n  .d0{animation-delay:0.0s}\n  .d1{animation-delay:0.1s}\n  .d2{animation-delay:0.2s}\n  .d3{animation-delay:0.3s}\n  .d4{animation-delay:0.4s}\n  .d5{animation-delay:0.5s}\n  .d6{animation-delay:0.6s}\n  .d7{animation-delay:0.7s}\n  .d8{animation-delay:0.8s}\n  .d9{animation-delay:0.9s}\n  .d10{animation-delay:1.0s}\n  .d11{animation-delay:1.1s}\n  .d12{animation-delay:1.2s}\n  .d13{animation-delay:1.3s}\n  .d14{animation-delay:1.4s}\n  .d15{animation-delay:1.5s}\n  .d16{animation-delay:1.6s}\n  .d17{animation-delay:1.7s}\n  .d18{animation-delay:1.8s}\n  .d19{animation-delay:1.9s}\n  .d20{animation-delay:2.0s}\n  .d21{animation-delay:2.1s}\n  .d22{animation-delay:2.2s}\n  .d23{animation-delay:2.3s}\n  .d24{animation-delay:2.4s}\n  .d25{animation-delay:2.5s}\n  .d26{animation-delay:2.6s}\n  .d27{animation-delay:2.7s}\n  .d28{animation-delay:2.8s}\n  .d29{animation-delay:2.9s}\n  .d30{animation-delay:3.0s}\n  .d31{animation-delay:3.1s}\n  .d32{animation-delay:3.2s}\n  .d33{animation-delay:3.3s}\n  .d34{animation-delay:3.4s}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "scene"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e3",
    d: "M 250.3 173.1 L 444.6 285.3 L 261.7 390.9 L 67.4 278.7 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 244.6,
    y1: 202.8,
    x2: 118.8,
    y2: 275.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 281.7,
    y1: 224.2,
    x2: 156,
    y2: 296.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 318.9,
    y1: 245.7,
    x2: 193.1,
    y2: 318.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 356,
    y1: 267.1,
    x2: 230.3,
    y2: 339.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 393.2,
    y1: 288.6,
    x2: 267.4,
    y2: 361.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 244.6,
    y1: 202.8,
    x2: 393.2,
    y2: 288.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 202.7,
    y1: 227,
    x2: 351.3,
    y2: 312.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 160.7,
    y1: 251.2,
    x2: 309.3,
    y2: 337
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 118.8,
    y1: 275.4,
    x2: 267.4,
    y2: 361.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 336 280 L 261.7 322.9 L 261.7 328.2 L 336 285.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 164.5 266.8 L 261.7 322.9 L 261.7 328.2 L 164.5 272.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 238.9 223.9 L 336 280 L 261.7 322.9 L 164.5 266.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 238.9 223.9 L 336 280 L 261.7 322.9 L 164.5 266.8 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 336,
    y1: 280,
    x2: 336,
    y2: 285.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 261.7,
    y1: 322.9,
    x2: 261.7,
    y2: 328.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 164.5,
    y1: 266.8,
    x2: 164.5,
    y2: 272.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 336,
    y1: 285.3,
    x2: 261.7,
    y2: 328.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 261.7,
    y1: 328.2,
    x2: 164.5,
    y2: 272.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 336 268.8 L 261.7 311.7 L 261.7 317 L 336 274.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 164.5 255.6 L 261.7 311.7 L 261.7 317 L 164.5 260.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 238.9 212.7 L 336 268.8 L 261.7 311.7 L 164.5 255.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 238.9 212.7 L 336 268.8 L 261.7 311.7 L 164.5 255.6 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 336,
    y1: 268.8,
    x2: 336,
    y2: 274.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 261.7,
    y1: 311.7,
    x2: 261.7,
    y2: 317
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 164.5,
    y1: 255.6,
    x2: 164.5,
    y2: 260.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 336,
    y1: 274.1,
    x2: 261.7,
    y2: 317
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 261.7,
    y1: 317,
    x2: 164.5,
    y2: 260.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 336 257.6 L 261.7 300.5 L 261.7 305.8 L 336 262.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 164.5 244.4 L 261.7 300.5 L 261.7 305.8 L 164.5 249.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 238.9 201.5 L 336 257.6 L 261.7 300.5 L 164.5 244.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 238.9 201.5 L 336 257.6 L 261.7 300.5 L 164.5 244.4 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 336,
    y1: 257.6,
    x2: 336,
    y2: 262.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 261.7,
    y1: 300.5,
    x2: 261.7,
    y2: 305.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 164.5,
    y1: 244.4,
    x2: 164.5,
    y2: 249.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 336,
    y1: 262.9,
    x2: 261.7,
    y2: 305.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 261.7,
    y1: 305.8,
    x2: 164.5,
    y2: 249.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 336 246.4 L 261.7 289.3 L 261.7 294.5 L 336 251.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 164.5 233.2 L 261.7 289.3 L 261.7 294.5 L 164.5 238.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 238.9 190.3 L 336 246.4 L 261.7 289.3 L 164.5 233.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 238.9 190.3 L 336 246.4 L 261.7 289.3 L 164.5 233.2 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 336,
    y1: 246.4,
    x2: 336,
    y2: 251.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 261.7,
    y1: 289.3,
    x2: 261.7,
    y2: 294.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 164.5,
    y1: 233.2,
    x2: 164.5,
    y2: 238.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 336,
    y1: 251.6,
    x2: 261.7,
    y2: 294.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 261.7,
    y1: 294.5,
    x2: 164.5,
    y2: 238.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 234.6,
    y1: 214.2,
    x2: 306,
    y2: 255.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 217.4,
    y1: 224.1,
    x2: 288.9,
    y2: 265.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 200.3,
    y1: 234,
    x2: 271.7,
    y2: 275.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 183.1,
    y1: 243.9,
    x2: 254.6,
    y2: 285.1
  }), /*#__PURE__*/React.createElement("g", {
    className: "drift d4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 247.4 174.8 L 321.7 217.6 L 264.6 250.6 L 190.3 207.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M 247.4 174.8 L 321.7 217.6 L 264.6 250.6 L 190.3 207.8 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a2",
    x1: 244.6,
    y1: 187.6,
    x2: 291.7,
    y2: 214.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "a2",
    x1: 230.3,
    y1: 195.9,
    x2: 277.4,
    y2: 223.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "a2",
    x1: 216,
    y1: 204.1,
    x2: 263.1,
    y2: 231.3
  })), /*#__PURE__*/React.createElement("line", {
    className: "a2 flow",
    x1: 256,
    y1: 250.7,
    x2: 256,
    y2: 216
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "halo d2",
    cx: 256,
    cy: 197.9,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 256,
    cy: 197.9,
    r: 3.8
  })), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d0",
    cx: 118,
    cy: 128,
    r: 3.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d11",
    cx: 398,
    cy: 150,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d20",
    cx: 424,
    cy: 322,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d6",
    cx: 92,
    cy: 306,
    r: 2.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d26",
    cx: 352,
    cy: 96,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d13",
    cx: 128,
    cy: 402,
    r: 2.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.263aa03de0975964b58ea8236a6759f5.svg";
export { ForwardRef as ReactComponent };